import {
  FETCH_PROGRAM_DVRS_SUCCESS,
  SCHEDULE_DVR_SUCCESS
} from '../actions/channels'
import {
  FETCH_DVRS_REQUEST,
  FETCH_DVRS_SUCCESS,
  FETCH_DVRS_FAILURE,
  FETCH_DVR_REQUEST,
  FETCH_DVR_SUCCESS,
  FETCH_DVR_FAILURE,
  FETCH_DVR_WARNING,
  DISMISS_ERROR,
  SET_FOCUSED_FILTER,
  SET_SELECTED_FILTER,
  SET_FOCUSED_SECTION,
  SET_FOCUSED_POSITION,
  UPDATE_CURRENT_TIME,
  REMOVE_DVR_SUCCESS
} from '../actions/dvr'
import { LOGIN_SUCCESS } from '../actions/login'
import { LOGOUT_SUCCESS } from '../actions/logout'

export const statusList = ['recorded', 'recording', 'scheduled', 'failed']
export const statusLabelList = {
  recorded: 'Recorded Videos',
  recording: 'Recording Now',
  scheduled: 'Scheduled',
  failed: 'Failed'
}

const INITIAL_STATE = {
  isReady: false,
  hasError: false,
  errorMessage: '',
  lastUpdated: -1,
  allIds: [],
  byId: {},
  selectedFilter: 'all',
  focusedFilter: 'all',
  focusedSection: 'filters',
  focusedPosition: {
    recorded: 0,
    recording: 0,
    scheduled: 0,
    failed: 0
  },
  filterList: ['all'],
  filterLabelList: {
    all: 'All Recordings'
  },
  overviewId: -1
}

const dvrAppReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case DISMISS_ERROR:
    case SCHEDULE_DVR_SUCCESS:
      return {
        ...INITIAL_STATE
      }

    case FETCH_DVRS_REQUEST:
      return {
        ...state,
        isReady: false,
        hasError: false,
        errorMessage: ''
      }
    case FETCH_DVRS_SUCCESS:
      return {
        ...state,
        isReady: true,
        byId: action.payload.byId,
        allIds: action.payload.allIds,
        lastUpdated: Date.now(),
        filterList: ['all', ...action.payload.filterList],
        filterLabelList: Object.assign(
          {},
          INITIAL_STATE.filterLabelList,
          action.payload.filterLabelList
        ),
        overviewId:
          action.payload.allIds.length > 0 ? action.payload.allIds[0].id : -1
      }
    case FETCH_DVRS_FAILURE:
      return {
        ...state,
        isReady: true,
        hasError: true,
        errorMessage: action.payload.message
      }
    case FETCH_DVR_REQUEST:
      const current = {
        ...state.byId[action.payload.id],
        loading: true
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: current
        }
      }
    case FETCH_DVR_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...action.payload,
            lastUpdated: Date.now()
          }
        }
      }
    case FETCH_DVR_WARNING:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.meta.id]: {
            ...state.byId[action.meta.id],
            lastUpdated: Date.now()
          }
        }
      }
    case FETCH_DVR_FAILURE:
      const newDvrDetails = {
        ...state.byId[action.meta.id],
        lastUpdated: Date.now(),
        loading: false,
        hasError: true,
        errorMessage: action.payload.message
      }
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.meta.id]: newDvrDetails
        }
      }
    case SET_FOCUSED_FILTER:
      return {
        ...state,
        focusedSection: 'filters',
        focusedFilter: action.payload
      }
    case SET_SELECTED_FILTER:
      return {
        ...state,
        focusedSection: 'filters',
        selectedFilter: action.payload,
        focusedFilter: action.payload,
        focusedPosition: {
          ...state.focusedPosition,
          recorded: 0
        }
      }
    case SET_FOCUSED_SECTION:
      return {
        ...state,
        focusedSection: action.payload,
        overviewId: newOverview(
          state,
          action.payload,
          state.focusedPosition[action.payload]
        )
      }
    case SET_FOCUSED_POSITION:
      return {
        ...state,
        focusedPosition: {
          ...state.focusedPosition,
          [action.payload.status]: action.payload.position
        },
        overviewId: newOverview(
          state,
          state.focusedSection,
          action.payload.position
        )
      }
    case UPDATE_CURRENT_TIME:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            currentTime: action.payload.currentTime
          }
        }
      }

    case REMOVE_DVR_SUCCESS:
      let newById = { ...state.byId }
      delete newById[action.payload.id]
      return {
        ...state,
        allIds: state.allIds.filter(id => id !== action.payload.id),
        byId: newById
      }

    case FETCH_PROGRAM_DVRS_SUCCESS:
      if (!state.isReady) {
        return state
      }
      const newIds = Object.keys(action.payload)
      if (newIds.length !== state.allIds.length) {
        return {
          ...state,
          isReady: false
        }
      }
      const diff = state.allIds.filter(id => newIds.indexOf(id.toString()) < 0)
      return {
        ...state,
        isReady: diff.length === 0
      }

    default:
      return state
  }
}

const newOverview = (state, section, position) => {
  const allDvrs = state.allIds.map(id => state.byId[id])
  const sectionDvrs = allDvrs.filter(dvr => {
    if (section === 'recorded' && state.selectedFilter !== 'all') {
      return (
        dvr.status === 'recorded' &&
        typeof dvr.category !== 'undefined' &&
        dvr.category.toLowerCase().replace(' ', '') === state.selectedFilter
      )
    } else {
      return dvr.status === section
    }
  })

  if (sectionDvrs.length > 0 && typeof sectionDvrs[position] !== 'undefined') {
    return sectionDvrs[position].id
  }

  return -1
}

export default dvrAppReducer
